import TimelineComponent from './TimeLine';

function Movimientos({ ...props }: any) {
    return <TimelineComponent {...props} />;
}

export default Movimientos;
